import React from 'react'
import styled from '@emotion/styled'
import { Grid, GridProps } from '@mui/material'
const StyledGrid = styled(Grid)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center'
})

const VerticalStackGrid = (props: GridProps) => {
  const { children, ...otherProps } = props
  return (
    <StyledGrid item {...otherProps}>
      {children}
    </StyledGrid>
  )
}

export default VerticalStackGrid
